import { CABS_ROUTE_BASE, CABS_SERVICE_KEY, CABS_SERVICE_PARAM } from './constants';

export const buildCabsRedirect = (search = '') => {
  const params = new URLSearchParams(search || '');
  if (params.get(CABS_SERVICE_PARAM) !== CABS_SERVICE_KEY) return null;
  params.delete(CABS_SERVICE_PARAM);
  const query = params.toString();
  return query ? `${CABS_ROUTE_BASE}?${query}` : CABS_ROUTE_BASE;
};

export const omitEmptyParams = (input = {}) => {
  const params = new URLSearchParams();
  Object.entries(input).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });
  return params;
};

const FALLBACK_COLORS = {
  sedan: '#0f172a',
  suv: '#1f2937',
  tempo: '#0f766e',
  bus: '#7c2d12',
};

const buildFallbackSvg = (label, color) => {
  const safeLabel = String(label || 'Cab').slice(0, 20);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="520">` +
    `<rect width="100%" height="100%" fill="${color}"/>` +
    `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Arial" font-size="48" fill="#ffffff">${safeLabel}</text>` +
    `</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

export const getCategoryFallbackImage = (categoryName) => {
  const key = String(categoryName || '').toLowerCase();
  let label = 'Cab';
  let color = '#0f172a';
  if (key.includes('sedan')) {
    label = 'Sedan';
    color = FALLBACK_COLORS.sedan;
  } else if (key.includes('suv')) {
    label = 'SUV';
    color = FALLBACK_COLORS.suv;
  } else if (key.includes('tempo')) {
    label = 'Tempo';
    color = FALLBACK_COLORS.tempo;
  } else if (key.includes('bus')) {
    label = 'Bus';
    color = FALLBACK_COLORS.bus;
  }
  return buildFallbackSvg(label, color);
};
